import { useCallback, useEffect } from "react";
import { toast } from "react-toastify";

import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useRevisao = () => {
  const { request, data, errors, isLoading } = useApiClient();

  const Revisar = useCallback(
    (sqTipoOcorrencia, dsTipoOcorrencia) => {
      const params = {
        SqTipoOcorrencia: sqTipoOcorrencia ?? 0,
        dsStatus: dsTipoOcorrencia,
      };

      request(apiRoutes.fiscalizacao.parametrizacao.revisarOcorrencia, params);
    },
    [request],
  );

  useEffect(() => {
    if (isLoading) return;

    if (!data && !errors) return;

    if (data) {
      toast.success("Status da Ocorrência alterado com sucesso.");
      window.location.reload();
    } else if (errors) {
      toast.error(errors.message);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors, isLoading]);

  return { isLoading, Revisar };
};

export default useRevisao;
